<template>
  <CFooter :fixed="false">
    <div>
      <a href="#" target="_blank">PFE MASTER CROWD COUNTING</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} | USTHB.</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Designed by</span>
      <a href="#" target="_blank"><i>Hadjerci &  Selmane</i></a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
